import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { LoginModalComponent } from './login-modal.component';

@NgModule({
  declarations: [LoginModalComponent],
  imports: [
    CommonModule,
    CommonModule,
    FormsModule,
    IonicModule
  ],
  exports: [LoginModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoginModalModule { }
